import { resolveIdentifier, types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';
import { PharmacyBase } from './PharmacyBase';
import { PharmacyUser } from './PharmacyUser';
import { PharmacyStatus } from './PharmacyStatus';
import { Secretariat } from './Secretariat';
import { Group } from './Group';
import { Anchor } from './Anchor';

export const Pharmacy = types.compose(
  'Pharmacy',
  BaseEntity,
  PharmacyBase,
  types
    .model({
      phone: types.maybe(types.string),
      mobile: types.maybe(types.string),
      address: types.maybe(types.string),
      zipCode: types.maybe(types.string),
      groupId: types.maybe(types.integer),
      anchorId: types.maybe(types.number),
      zoneId: types.maybe(types.integer),
      density: types.maybe(types.integer),
      secretariatId: types.maybe(types.integer),
      latitude: types.maybe(types.number),
      longitude: types.maybe(types.number),
      x: types.maybe(types.number),
      y: types.maybe(types.number),
      prefDutyDayOn: types.maybe(types.string),
      prefDutyDayOff: types.maybe(types.string),
      municipalityId: types.maybe(types.integer),
      statusId: types.maybe(types.number),
      sharedDutiesGroupId: types.maybe(types.number),
      userId: types.maybe(types.integer),
      pharmacyUsers: types.optional(types.array(PharmacyUser), []),
      email: types.maybe(types.string),
      firstname: types.maybe(types.string),
      lastname: types.maybe(types.string),
      statusName: types.maybe(types.string),
    })
    // Holds a group object assigned imperatively (e.g. by the calendar) that
    // takes precedence over identifier resolution. Volatile so it never becomes
    // an MST property (which would collide with the `group` view below and break
    // snapshots on models that compose Pharmacy, such as PharmacyDetails).
    .volatile(() => ({
      groupOverride: undefined as any,
    }))
    .views((self) => ({
      get status() {
        if (self.statusId === undefined) {
          return undefined;
        }
        return resolveIdentifier(PharmacyStatus, self, self.statusId);
      },
      // get user() {
      //   if (self.userId === undefined) {
      //     return undefined;
      //   }
      //   return resolveIdentifier(User, self, self.userId);
      // },
      get secretariat() {
        if (self.secretariatId === undefined) {
          return undefined;
        }
        return resolveIdentifier(Secretariat, self, self.secretariatId);
      },
      get group() {
        if (self.groupOverride !== undefined) {
          return self.groupOverride;
        }
        if (self.groupId === undefined) {
          return undefined;
        }
        return resolveIdentifier(Group, self, self.groupId);
      },
      get anchorName() {
        if (self.anchorId === undefined) {
          return undefined;
        }
        return resolveIdentifier(Anchor, self, self.anchorId);
      },
    }))
    .actions((self) => ({
      setGroup(group: any) {
        self.groupOverride = group;
      },
    })),
);
